interface CareHistoryItem {
  id: string;
  match_number: string;
  start_date: string;
  end_date: string;
  care_end_date: string;
  location: string;
  hourly_rate: number;
  daily_hours: number;
  total_amount: number;
  completed_at: string;
  patient_name: string;
  patient_phone: string;
}

const FEE_RATE = 0.05;

function escapeCsv(value: string | number): string {
  const str = String(value);
  if (str.includes(',') || str.includes('"') || str.includes('\n')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

export function exportCareHistoryToCsv(items: CareHistoryItem[], year: number) {
  const headers = [
    '매칭번호',
    '환자명',
    '간병시작일',
    '간병종료일',
    '총 간병일수',
    '근무조건',
    '간병장소',
    '총 간병비(원)',
    '중개 수수료(원)',
    '실수령액(원)',
    '완료일',
  ];

  const rows = items.map((item) => {
    const fee = Math.round((item.total_amount || 0) * FEE_RATE);
    const net = (item.total_amount || 0) - fee;
    const careDays = (() => {
      if (item.start_date && item.care_end_date) {
        const start = new Date(item.start_date);
        const end = new Date(item.care_end_date);
        const days = Math.ceil((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24)) + 1;
        return days > 0 ? days : 0;
      }
      return 0;
    })();

    const workCondition = `${(item.hourly_rate || 0).toLocaleString()}원 × ${item.daily_hours || '-'}시간/일`;

    return [
      escapeCsv(item.match_number || ''),
      escapeCsv(item.patient_name || ''),
      escapeCsv(item.start_date || ''),
      escapeCsv(item.care_end_date || ''),
      careDays,
      escapeCsv(workCondition),
      escapeCsv(item.location || ''),
      item.total_amount || 0,
      fee,
      net,
      escapeCsv(item.completed_at?.split('T')[0] || ''),
    ];
  });

  const totalAmount = items.reduce((s, i) => s + (i.total_amount || 0), 0);
  const totalFee = Math.round(totalAmount * FEE_RATE);
  const totalNet = totalAmount - totalFee;
  const totalDays = items.reduce((s, i) => {
    if (i.start_date && i.care_end_date) {
      const start = new Date(i.start_date);
      const end = new Date(i.care_end_date);
      const days = Math.ceil((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24)) + 1;
      return s + (days > 0 ? days : 0);
    }
    return s;
  }, 0);

  const summary = [
    '',
    '합계',
    '',
    '',
    totalDays,
    '',
    '',
    totalAmount,
    totalFee,
    totalNet,
    '',
  ];

  const csvContent = [
    `\uFEFF${year}년 간병 이력 내역 (소득세 신고용)`,
    `작성일: ${new Date().toLocaleDateString('ko-KR')}`,
    `수수료율: ${(FEE_RATE * 100).toFixed(0)}%`,
    '',
    headers.join(','),
    ...rows.map((r) => r.join(',')),
    summary.join(','),
  ].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${year}년_간병이력_소득세신고용.csv`;
  link.click();
  URL.revokeObjectURL(url);
}